import QuestionItem from './QuestionItem.container';

export default QuestionItem;
